import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

// A layout, not a page: the roster lives in ./product-areas/index.tsx so its
// child routes actually mount. Without the Outlet the reconciliation and setup
// routes resolve and then render the roster instead.
export const Route = createFileRoute("/_authed/tenants/$slug/settings/product-areas")({
  beforeLoad: ({ context, params }) => {
    if (!context.authority.permissions.includes("product_areas.read")) {
      throw redirect({ to: "/tenants/$slug/settings", params: { slug: params.slug }, replace: true });
    }
  },
  component: Outlet,
});
